import React, { useState, useCallback, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    requestPristine,
    requestPending,
} from "state/reducer/requestStatusSlice";
import { /*ICustomer,*/ IContract, IDocument } from "dataModels/contract";
import { getContract, downloadInfo, downloadDocument, deleteEntity } from "net/contracts";
//import axios from "axios";
import moment from "moment";
import {
    DATE_FORMAT,
    BadgeStatus,
    RoutePath,
    DocumentType,
    EntityType,
    IAppUserProfile,
    DsLayout,
    ResponseStatus,
    ResponseCode,
} from "shared/constants";
import "views/contractView/styles/contractDataStyles.css";
import { Button, Output, Table } from "@ds/ds-snam/react";
import { saveAs } from "file-saver";
import SimpleTable, { SimpleTableType } from "components/SimpleTable";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Textlink } from "@ds/ds-snam/react";
import ContractLimitsDisplay from "views/contractView/components/contractLimitsDisplay";
import ContractSlotChart from "views/contractView/components/contractSlotChart";
import DsHorizontalDivider from "components/DsHorizontalDivider";
import DsBadge from "components/DsBadge";
import useAppUser from "hooks/useAppUser";
import { RootState } from "state/appStore";
import { IParseDateFormatType, parseDateForDS } from "shared/utils/dateUtils";
import { ITableCell, ITableConfig, ITableRow } from "@ds/ds-snam/dist/models/tables";
import { getDSTableShaderElementsForFilterColumn,getDSTableSharedElements, getTableCellsHeaderSimple  } from "shared/utils/dsComponentUtils";
import { Col, Row } from "react-grid-system";
import ConfirmPopUp from "components/ConfirmPopUp";
import { INotificationAction, NotificationsStatusType } from "dataModels/stateModels/notification";
import { hideNotification, showNotification } from "state/reducer/notificationSlice";
import ContractDataDisplay from "./contractDataDisplay";


const ContractData: React.FC = (): JSX.Element => {
    const { t, i18n } = useTranslation(["contract", "app"]);
    const { id} = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const layoutMode = useSelector((state: RootState) => {
        return state.dsLayout.mode;
    });
    const appUserProfile: IAppUserProfile | undefined =
        useAppUser()?.userProfile;

    const [contractData, setContractData] = useState<IContract>();
    const [showConfirm, setShowConfirm] = useState<boolean>(false);
    const dispatch = useDispatch();
    const loadData = useCallback(() => {
        dispatch(requestPending());
        getContract(id!)
            .then((response) => {
                const contractResponse = response.data;
                /*let mock:IContract = {
                "id": "56",
                "customerId": "3",
                "customerName": "ACME 2",
                "customerVat": "05566778800",
                "code": "Contract Pignataro",
                "startDate": 1747822408,
                "endDate": 2019420000,
                "slot": 15,
                "topPercentage": 10.0000,
                
                "rateLoading": 1.0000,
                "rateLoadingBio": 2.0000,
                "rateCoolDown": 3.0000,
                "rateGasUp": 4.0000,
                "rateSemiTrailerApproval": 5.0000,
                "rateDriverApproval": 6.0000,
                "rateSemiTrailerAndDriverApproval": 7.0000,
                "rateIsoContainerApproval": 8.0000,
                "rateIsoContainerAndDriverApproval": 9.0000,

                "rateLoadingMWh": 11.0000,
                "rateLoadingBioMWh": 22.0000,
                "rateCoolDownMWh": 33.0000,
                "rateGasUpMWh": 44.0000,
                "rateSemiTrailerApprovalMWh": 55.0000,
                "rateDriverApprovalMWh": 66.0000,
                "rateSemiTrailerAndDriverApprovalMWh": 77.0000,
                "rateIsoContainerApprovalMWh": 88.0000,
                "rateIsoContainerAndDriverApprovalMWh": 99.0000,

                "rateLoadingLastMinute": 1777.0000,
                "rateLoadingLastMinuteMWh": 1777.0000,

                "rateTruckTractorApproval": 0.0000,
                "rateContainerPlatformApproval": 0.0000,
                
                "fineFailureTake": 1.0000,
                "rateLoadingAvailable": true,
                "rateLoadingBioAvailable": true,
                "rateCoolDownAvailable": true,
                "rateGasUpAvailable": true,
                "rateSemiTrailerApprovalAvailable": true,
                "rateDriverApprovalAvailable": true,
                "rateSemiTrailerAndDriverApprovalAvailable": true,
                "rateIsoContainerApprovalAvailable": true,
                "rateIsoContainerAndDriverApprovalAvailable": true,
                "rateTruckTractorApprovalAvailable": true,
                "rateContainerPlatformApprovalAvailable": true,
                "rateLoadingAvailablePlant": true,
                "rateLoadingBioAvailablePlant": true,
                "rateCoolDownAvailablePlant": true,
                "rateGasUpAvailablePlant": true,
                "rateSemiTrailerApprovalAvailablePlant": true,
                "rateDriverApprovalAvailablePlant": true,
                "rateSemiTrailerAndDriverApprovalAvailablePlant": true,
                "rateIsoContainerApprovalAvailablePlant": true,
                "rateIsoContainerAndDriverApprovalAvailablePlant": true,
                "rateTruckTractorApprovalAvailablePlant": true,
                "rateContainerPlatformApprovalAvailablePlant": true,
                "documents": [
                    {
                        "type": "contract",
                        "name": "AAAAAAAAAA.pdf",
                        "size": 142662,
                        "content": "",
                        "expire": 2114290800,
                        "status": 0
                    }
                ],
                "limits": [],
                "chartData": [
                    {
                        "title": "Bookable slots",
                        "titleLegend": "Bookable slots",
                        "value": 15,
                        "color": "--charts-bluegrey-1"
                    },
                    {
                        "title": "Booked slots",
                        "titleLegend": "Booked slots",
                        "value": 0,
                        "color": "--charts-petrol-2"
                    },
                    {
                        "title": "Used slots",
                        "titleLegend": "Used slots",
                        "value": 0,
                        "color": "--charts-indigo-2"
                    }
                ]
            }
                
            setContractData(mock);*/
            setContractData(contractResponse);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            });
    }, [dispatch, id]);

    useEffect(() => {
        if (id) loadData();
    }, [id, i18n.language, loadData]);

    const downloadContractInfo = () => {
        //downloadContract(contractData!.id!)
        downloadInfo(id!, EntityType.CONTRACT)
            .then((response) => {
                let file = new File(
                    [response.data],
                    "contract_" + contractData!.id! + ".pdf"
                );
                saveAs(file);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const downloadContractDocument = (documentType: DocumentType) => {
        downloadDocument(contractData!.id!, EntityType.CONTRACT, documentType)
            .then((response) => {
                let file = new File(
                    [response.data],
                    "contractDocument_" + contractData!.id! + ".pdf"
                );
                saveAs(file);
            })
            .catch((error) => {
                console.log(error);
            });
    };
    const getBadgeStatus = (status: BadgeStatus, isSmall?: boolean) => {
        return status === BadgeStatus.VALID ? "confirm" : "error";
    };

    const documentTableCols = (() => {
        //return ["Nome", "Data fine validità", ""]
        return t("contract.contractData.fileTable.tableColumns", {
            ns: "contract",
            returnObjects: true,
        }) as string[];
    })();
    const documentTableRows = contractData?.documents.map(
        (document: IDocument, index) => {
            return (
                <tr key={uuidv4()}>
                    <td>
                        <span
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >
                            <DsBadge
                                notificationStatus={getBadgeStatus(
                                    document.status!
                                )}
                            />
                            {/*document.name*/}
                            {t(
                                "contract.contractData.fileTable.fileTypes.contract"
                            )}
                        </span>
                    </td>
                    <td>
                        {document && document.expire
                            ? moment.unix(document.expire).format(DATE_FORMAT)
                            : ""}
                    </td>
                    <td style={{ textAlign: "center" }}>
                        {appUserProfile?.editEntityPolicy.includes(EntityType.CONTRACT) && 
                        <Textlink
                            textlinkText={t("general.buttons.modify", {
                                ns: "app",
                            })} //"Modifica"
                            textlinkTextSize="SMALL"
                            isRouterLink={true}
                            onClickLink={() => {
                                navigate(
                                    RoutePath.CONTRACTS_EDIT_DOCUMENT +
                                        "?entityId=" +
                                        id +
                                        "&entityType=" +
                                        EntityType.CONTRACT +
                                        "&documentType=" +
                                        DocumentType.CONTRACT
                                );
                            }}
                        />}
                    </td>
                    <td>
                        <Button
                            buttonType="button"
                            buttonUIVariant="tertiary"
                            buttonSize="medium"
                            buttonLabel=""
                            buttonIcon="icon-download"
                            isDisabled={false}
                            buttonAriaLabel="Aria text here"
                            onClickEvent={(event: Event) => {
                                downloadContractDocument(
                                    document.type as DocumentType
                                );
                            }}
                        ></Button>
                    </td>
                </tr>
            );
        }
    );
    const getTableRowsContractDocs = (): ITableRow[] => {
            let myRetArr: ITableRow[] = [];
            let test : ITableCell
            if (contractData?.documents) {
                for (let i = 0; i < contractData.documents.length; i++) {
                    let tempObj: ITableRow = {
                        tableCells: [
                            { 
                                type: "text-badge", 
                                text: contractData.documents[i].name,
                                badgeStatus: contractData.documents[i].status ===BadgeStatus.VALID?"confirm": "error",
                            },
                            { 
                                type: "text", 
                                text: (contractData.documents[i] && contractData.documents[i].expire) ? moment.unix(contractData.documents[i].expire as number).format(DATE_FORMAT) : ""
                            },
                            /*{
                                type : "link",
                                text : t("general.buttons.modify", {ns: "app",}),
                                linkAriaLabel : t("general.buttons.modify", {ns: "app",}),
                                disabled: appUserProfile?.editEntityPolicy.includes(EntityType.CONTRACT) ? false : true,
                                isRouterLink:true
                            }*/
                        ],
                        //rightIcon: "icon-download",
                        rightIconMenu:true,
                        "rightIconMenuData":[
                            {
                                "actionLabel": t("general.buttons.modify",{ ns: "app" }),
                                "actionAriaLabel": t("general.buttons.modify",{ ns: "app" }), //EDIT
                                "actionDisabled": appUserProfile?.editEntityPolicy.includes(EntityType.CONTRACT) ? false : true,
                            },
                            {
                                "actionLabel": t("general.buttons.download_short",{ ns: "app" }),
                                "actionAriaLabel": t("general.buttons.download_short",{ ns: "app" }), //DOWNLOAD
                                "actionDisabled": false,
                            }
                        ]
                        
                    };
                    myRetArr.push(tempObj);
                }
            }
            return myRetArr;
        };
    const myTableConfigContractDocs: ITableConfig = {
                    ...getDSTableSharedElements(),
                    tableHeader: {
                        
                        tableCellsHeader: [
                            getTableCellsHeaderSimple(t("contract.contractData.fileTable.tableColumns.0", {ns: "contract"}) as string,"col1","50%","left"),
                            getTableCellsHeaderSimple(t("contract.contractData.fileTable.tableColumns.1", {ns: "contract"}) as string,"col2","50%","left"),
                        ],
                        hasSearchBox: true,
                    },
                    tableRows: getTableRowsContractDocs()
    };

    const deleteContract = useCallback(() => {
        dispatch(requestPending());
        deleteEntity(id!, EntityType.CONTRACT)
            .then((response) => {
                const popUpTitle: string = response.data.status === ResponseStatus.ERROR ? "Error" : (response.data.code === ResponseCode.UNPROCESSABLE_CONTENT ? 'UNPROCESSABLE CONTENT' : t(`contract.contractData.deleteSuccessTitle`));
                const popUpDescription: string = response.data.status === ResponseStatus.ERROR || response.data.code === ResponseCode.UNPROCESSABLE_CONTENT ? response.data.message : t(`contract.contractData.deleteSuccessSubtitle`);
                const popUpStatus: NotificationsStatusType = response.data.status === ResponseStatus.ERROR ? "error" : (response.data.code === ResponseCode.UNPROCESSABLE_CONTENT ? "warning" : "confirm");  
                const popupAction: INotificationAction = {
                    show: true,
                    title: popUpTitle, 
                    description: popUpDescription, 
                    status: popUpStatus,
                    onClose: (event: Event) => {
                        dispatch(hideNotification());
                    },
                };
                dispatch(showNotification(popupAction));
                navigate(RoutePath.CONTRACTS_CONTRACT_INFO);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            });
    }, [id, dispatch, navigate]);

    const isContractValid = (contractData:IContract) => {
        const now = Date.now() / 1000; // timestamp in secondi
      
        if (
          contractData.endDate < now &&
          contractData.documents[0] && 
          contractData.documents[0].expire !==null &&
          contractData.documents[0].expire < now
        ) {
          return false;
        }
      
        return true;
      };

     const getContractStatusBadge = () => {
            let notificationStatus: string = "";
            let statusMessage: string = "";
    
            if (isContractValid(contractData!)) {
                notificationStatus = "confirm";
                statusMessage =t("contract.contractList.tableLegend.2")
            } else {
                notificationStatus = "error";
                statusMessage = t("contract.contractList.tableLegend.1")
            }
    
            return <div style={{ display: "flex", width: "163px", justifyContent: "flex-end", alignItems: "center", gap: "8px" }}><ds-notification-badge
                notification-status={notificationStatus}
                badge-variant="default"
                badge-number="0"
                badge-aria-label="Badge aria label"
                is-small={true}
                background-color=""
            ></ds-notification-badge>
                <span className="statusMessage">
                    {statusMessage}
                </span></div>
    
        }

    return (
        <>
            {/*<p className="pageTitle" style={{ marginBottom: "10px" }}>
                {t("contract.contractData.title")}
            </p>*/}
            <Row>
                        <Col>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div style={{ display: "flex", alignItems: "flex-start", flexDirection: "column" }}>
                                    <p className="pageTitle" style={{ marginTop: 0 }}>
                                        {t("contract.contractData.title")}
                                    </p>
                                    {/*{driverData?.status && driverData?.status === BadgeStatus.TOAPPROVE && <p className="pageSubTitle" style={{marginTop:'-20px'}}>
                                        {t('drivers.driverData.statusMessage.0')}
                                    </p>}
                                    {driverData?.status && driverData?.status === BadgeStatus.TO_CREDIT && <p className="pageSubTitle" style={{marginTop:'-20px'}}>
                                        {t('drivers.driverData.statusMessage.1')}
                                    </p>}*/}
                                </div>
                                <div>
                                    {contractData && getContractStatusBadge()}
                                </div>
                            </div>
                        </Col>
                    </Row>
            

                <div
                    style={{
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        marginBottom: "25px",
                    }}
                >
                    {appUserProfile?.deleteEntityPolicy.includes(
                        EntityType.CONTRACT
                    ) && (
                        <div className="column" style={{ float: "left" }}>
                            <Textlink
                                textlinkText={t(
                                    "contract.contractData.deleteButton"
                                )}
                                textlinkTextSize="SMALL"
                                isRouterLink={true}
                                onClickLink={() => {
                                    setShowConfirm(true);
                                }}
                            />
                        </div>
                    )}
                </div>


            {contractData && (
                <>
                    

                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "25px",
                        }}
                    >
                        <ds-avatar
                            avatar-type="icon"
                            avatar-size="large"
                        ></ds-avatar>
                        <div
                            style={{
                                height: "fit-content",
                                marginLeft: "10px",
                            }}
                        >
                            <div>
                                <div>
                                    <span className="avatarText">
                                        {t(
                                            "contract.contractData.avatar.label1"
                                        )}
                                    </span>
                                    <span className="avatarTitle">
                                        {" "}
                                        {contractData.customerName}
                                    </span>
                                </div>
                                <div>
                                    <span className="avatarText">
                                        {t(
                                            "contract.contractData.avatar.label2"
                                        )}
                                    </span>
                                    <span className="avatarTitle">
                                        {contractData.customerVat}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <ContractDataDisplay contractData={contractData}/>







                    <div className="buttonContainer--contract">
                        {appUserProfile?.editEntityPolicy.includes(
                            EntityType.CONTRACT
                        ) && (
                            <Button
                                buttonType="button"
                                buttonUIVariant="secondary"
                                buttonSize="medium"
                                buttonLabel={t("general.buttons.edit", {
                                    ns: "app",
                                })} //"Modifica info"
                                isDisabled={false}
                                buttonAriaLabel="edit customer button"
                                onClickEvent={() => {
                                    navigate(
                                        RoutePath.CONTRACTS_EDIT_CONTRACT +
                                            "/" +
                                            id
                                    );
                                }}
                            ></Button>
                        )}

                        <Button
                            buttonType="button"
                            buttonUIVariant="primary"
                            buttonSize="medium"
                            buttonLabel={t("general.buttons.download", {
                                ns: "app",
                            })} //"Scarica informazioni"
                            buttonIcon=""
                            isDisabled={false}
                            buttonAriaLabel="download info button"
                            onClickEvent={(event: Event) => {
                                downloadContractInfo();
                            }}
                        ></Button>
                    </div>
                </>
            )}








            {contractData && (
                <>
                    <p className="documentTableTitle--contract">
                        {t("contract.contractData.fileTable.title")}
                    </p>
                    <div
                        className="listTableContainer"
                        style={{ marginTop: "24px" }}
                    >
                        {/*
                            <SimpleTable
                            columns={documentTableCols}
                            rows={documentTableRows}
                            tableType={SimpleTableType.DOCUMENTS}
                        />
                        */}
                        {
                            <Table 
                                tableConfig={myTableConfigContractDocs} 
                                style={{}}
                                onColumnSorting={(event:Event)=>{
                                    //console.log(event)
                                }}
                                onInputSearchBarChange={(event:Event)=>{
                                    console.log((event as CustomEvent).detail.searchedText + " - " + (event as CustomEvent).detail.cells)
                                }}
                                onClickRightAction={(event:Event)=>{
                                }}
                                onTextLinkCellClick={(event:Event)=>{
                                    
                                }}
                                onClickKebabAction1={(event:Event)=>{
                                    navigate(
                                        RoutePath.CONTRACTS_EDIT_DOCUMENT +
                                            "?entityId=" +
                                            id +
                                            "&entityType=" +
                                            EntityType.CONTRACT +
                                            "&documentType=" +
                                            DocumentType.CONTRACT
                                    );
                                }}
                                onClickKebabAction2={(event:Event)=>{
                                    downloadContractDocument(contractData?.documents[0].type as DocumentType);
                                }}
                            />
                        }


                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                marginTop: "12px",
                            }}
                        >
                            <DsBadge
                                notificationStatus={getBadgeStatus(
                                    BadgeStatus.VALID
                                )}
                                isSmall={true}
                            />
                            <span className="legendaLabel--contract">
                                {t("contract.contractList.tableLegend.0")}
                            </span>
                            <DsBadge
                                notificationStatus={getBadgeStatus(
                                    BadgeStatus.EXPIRED
                                )}
                                isSmall={true}
                            />
                            <span className="legendaLabel--contract">
                                {t("contract.contractList.tableLegend.1")}
                            </span>
                        </div>
                    </div>
                    <DsHorizontalDivider />
                </>
            )}

            {
                /* Contract limits */
                contractData && (
                    <>
                        <ContractLimitsDisplay contract={contractData} />
                        <DsHorizontalDivider />
                    </>
                )
            }
            {
                /* Chart */
                contractData && (
                    <>
                        <p className="documentTableTitle--contract">
                            {t("contract.contractData.chart.title")}
                        </p>
                        <div
                            style={{
                                //borderRadius: "12px",
                                background:
                                    layoutMode === DsLayout.DARK_MODE
                                        ? "#081C3E"
                                        : "var(--Neutrali-0, #FFF)",
                                marginTop: "24px",
                            }}
                        >
                            <ContractSlotChart contract={contractData} />
                        </div>
                        <DsHorizontalDivider />
                    </>
                )
            }
            {showConfirm && (
                <ConfirmPopUp
                        title={t("contract.contractData.deleteTitle")} 
                        description={t("contract.contractData.deleteSubtitle")}
                    onClose={() => {
                        setShowConfirm(false);
                    }}
                    onConfirm={() => {
                        setShowConfirm(false);
                        deleteContract();
                    }}
                />
            )}
        </>
    );
};
export default ContractData;
